<template>
  <LibraryListItem>
    <DocumentScoreLink
      :id="document.id"
      :score="document.score_total_capped"
      :language-code="document.language_code"
      class="ml-5"
    />
    <PostTitleCompanyBadgesCell
      :title="document.title"
      :company="document.company"
      :is-external="document.is_external"
      :is-evergreen="document.is_evergreen"
      :language-code="document.language_code"
    />

    <div
      class="document-date"
      data-testid="revision-modified-date"
    >
      {{ document.revision_modified_at ? new Date(document.revision_modified_at).toLocaleDateString("en-US") : '' }}
    </div>
    <div
      class="document-date"
      data-testid="created-date"
    >
      {{ document.created_at ? new Date(document.created_at).toLocaleDateString("en-US") : '' }}
    </div>
    <PostLocationCell :location="document.location" />
    <PostReqIdCell
      :req-uuid="document.req_uuid"
      :ats-req-id="document.ats_requisition_id"
      :flexible-id="document.flexible_id"
      @library-req-report-track="emits('library-req-report-track', document)"
    />
    <div v-if="isAdmin" class="flagship-visibility">
      <DpplToggleButton
        :model-value="!document.is_hidden"
        :label="document.is_hidden ? 'Hidden' : 'Visible'"
        class="d-flex h-100 w-100 toggle"
        @click.stop
        @update:model-value="emits('flagship-toggle-update', {
          id: document.id,
          isHidden: document.is_hidden,
        })"
      />
    </div>
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import PostTitleCompanyBadgesCell from '@/components/library/listItemCells/PostTitleCompanyBadgesCell.vue';
import PostReqIdCell from '@/components/library/listItemCells/PostReqIdCell.vue';
import PostLocationCell from '@/components/library/listItemCells/PostLocationCell.vue';
import DpplToggleButton from '@/components/datapeople/DpplToggleButton.vue';
import DocumentScoreLink from '@/components/shared/DocumentScoreLink.vue';

defineProps({
  document: {
    type: Object,
    required: true,
  },
  isAdmin: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['library-req-report-track', 'flagship-toggle-update']);
</script>

<style lang="less" scoped>
:deep(.v-input) {
  &.toggle {
    .v-switch__track {
      background: @grey-600;
    }

    .v-label {
      color: @text-lighter !important;
    }

    .v-selection-control--dirty .v-switch__track {
      background: @basic-green;
    }

    .v-selection-control--dirty .v-label {
      color: @basic-green !important;
    }
  }
}
</style>
